import { createColumnHelper } from '@tanstack/react-table';

import { DecoratedNetwork } from '../types';

export const columnHelper = createColumnHelper<DecoratedNetwork>();
